import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../shared/Sidebar";
import Toolbar from "../shared/Toolbar";
import { useTheme } from "../../context/ThemeContext";

const Layout = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className={`${theme === "dark" ? "dark" : ""}`}>
      <div className="flex flex-col h-screen">
        {/* Toolbar */}
        <div className="relative z-50 h-[5vh] bg-secondary-light dark:bg-secondary-dark shadow-md">
          <Toolbar
            toggleDarkMode={toggleTheme}
            isDarkMode={theme === "dark"}
          />
        </div>

        <div className="relative z-0 flex h-[95vh]">
          {/* Sidebar */}
          <Sidebar />

          {/* Main Content */}
          <div className="flex-1 overflow-y-auto bg-primary-light dark:bg-primary-dark">
            <div className="bg-panel-light dark:bg-panel-dark">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
